const ru = {
  sinObra: "Без объекта",
  cat: { materiales: "Материалы", mano_obra: "Работа", subcontratas: "Субподряд", suministros: "Коммунальные услуги", fiscal: "Налоги / сборы" },
  rama: {
    albanil_oficial: "Каменщик (мастер)", fontanero: "Сантехник", electricista: "Электрик", carpinteria_madera: "Столярные работы",
    carpintero_aluminio: "Алюминиевые конструкции", gestion_residuos: "Вывоз отходов", transportes: "Перевозки",
    peones: "Разнорабочие / подсобники", gestiones_comerciales: "Коммерческие задачи",
  },
  exento: { si: "Без налога", marcar: "Отметить без налога", marcado: "Расход отмечен как освобождённый от налога", quitado: "Отметка «без налога» снята", error: "Не удалось обновить расход" },
  toast: {
    subida: "Изображение загружено", leyendo: "Изображение загружено · читаем данные счёта…", leidos: "Данные счёта прочитаны автоматически ✨",
    noLeidos: "Не удалось прочитать данные автоматически. Заполните их вручную.", errorSubir: "Не удалось загрузить изображение",
    registrado: "Расход сохранён", eliminado: "Расход удалён",
  },
  jornada: {
    titulo: "Рабочее время по объектам (лимит {{n}} ч/нед.)", totales: "Всего {{n}} ч",
    excesoObras: "Объектов: {{n}}", excesoTexto: "— превышено {{n}} ч работы в неделю. Проверьте нагрузку.",
    vacio: "Часы работы ещё не внесены. Добавьте расход категории «Работа» с объектом и часами.",
    semExcedidas: "Превышено недель: {{n}}", resumen: "{{h}} ч · недель: {{n}}", excesoSemana: "Превышение на {{h}} ч сверх законного лимита {{n}} ч.",
  },
  coste: { titulo: "Затраты по объектам", ver: "Открыть объекты / проекты →", obra: "Объект", materiales: "Материалы", manoObra: "Работа", total: "Всего затрат" },
  vacio: { titulo: "Расходов нет", hint: "Вносите счета за материалы, работу и субподряд" },
  tabla: { concepto: "Описание", categoria: "Категория", fecha: "Дата", horas: "Часы", total: "Итого", justificante: "документ", justificanteM: "Документ" },
  form: {
    escanea: "Отсканируйте счёт — мы заполним данные", quitar: "Убрать изображение", leyendo: "Читаем…", camara: "Сканировать камерой",
    subir: "Загрузить файл", analizando: "Анализ изображения…",
    ocrBloqueado: "Изображение можно прикрепить; автоматическое чтение с ИИ доступно начиная с тарифа «Квартальный».",
    concepto: "Описание", categoria: "Категория", proveedor: "Поставщик / компания", base: "Сумма без налога (€)", impuesto: "Налог",
    obra: "Объект / проект", irpf: "Удержание IRPF (специалисты)", sinRetencion: "Без удержания",
    isp: "Обратное начисление налога", ispNota: "(строительный субподрядчик выставляет счёт без НДС и IGIC)",
    exento: "Освобождён от налога", exentoNota: "(страховки, сборы, аренда жилья…)",
    horas: "Часы", rama: "Вид работ", datosFactura: "Данные счёта", numero: "№ счёта", hora: "Время покупки",
    nif: "NIF / CIF компании", registro: "№ в торговом реестре", opcional: "Необязательно", fecha: "Дата",
  },
};

export default ru;
